import FilterBar from "./filter-bar";
import { FilterMenuItem } from "./menu/types";
import { useFilterState } from "./use-filter-state";

interface TableFilterBarProps {
  filterMenuItemGroups: FilterMenuItem[][];
}

export function TableFilterBar({ filterMenuItemGroups }: TableFilterBarProps) {
  const {
    selectedValues,
    comparisonValues,
    booleanValues,
    hasActiveFilters,
    activeFilterEntries,
    handleSelectionChange,
    handleComparisonChange,
    handleBooleanChange,
    handleTextOperatorChange,
    removeFilter,
    removeCompoundGroup,
    removeCompoundCondition,
    toggleCompoundLogic,
    setCompoundCondition,
    addConditionToGroup,
    addCompoundGroup,
    clearAllFilters,
  } = useFilterState(filterMenuItemGroups);

  if (!hasActiveFilters) return null;

  return (
    <FilterBar
      filterMenuItemGroups={filterMenuItemGroups}
      activeFilterEntries={activeFilterEntries}
      selectedValues={selectedValues}
      comparisonValues={comparisonValues}
      booleanValues={booleanValues}
      onSelectionChange={handleSelectionChange}
      onComparisonChange={handleComparisonChange}
      onBooleanChange={handleBooleanChange}
      onTextOperatorChange={handleTextOperatorChange}
      onRemoveFilter={removeFilter}
      onRemoveCompoundGroup={removeCompoundGroup}
      onRemoveCompoundCondition={removeCompoundCondition}
      onToggleCompoundLogic={toggleCompoundLogic}
      onSetCompoundCondition={setCompoundCondition}
      onAddConditionToGroup={addConditionToGroup}
      onCreateCompoundGroup={addCompoundGroup}
      onClearAll={clearAllFilters}
    />
  );
}
